import React from 'react';
import { AccentTemplateInputUnbound } from './AccentTemplateInputUnbound';

export const AccentTemplateTextAreaUnbound = (props) => (
  <AccentTemplateInputUnbound {...props} multiline />
);

